import { Link } from "react-router-dom";
import Moment from "react-moment";
import "moment/locale/pt-br";
import { FeedPostMenu } from "../shared";

// Ícones ultra-avançados
const ARIcon = () => (<svg width="20" height="20" fill="currentColor"><circle cx="10" cy="10" r="9"/><text x="5" y="14" fontSize="8" fill="#fff">AR</text></svg>);
const ChallengeIcon = () => (<svg width="20" height="20" fill="currentColor"><rect x="2" y="2" width="16" height="16" rx="3"/><text x="4" y="14" fontSize="8" fill="#fff">🏆</text></svg>);
const LiveIcon = () => (<svg width="20" height="20" fill="red"><circle cx="10" cy="10" r="9"/><text x="3" y="14" fontSize="7" fill="#fff">LIVE</text></svg>);
const PrivacyIcon = () => (<svg width="20" height="20" fill="currentColor"><rect x="3" y="6" width="14" height="9" rx="2"/><circle cx="10" cy="10" r="2" fill="#fff"/></svg>);
const NotificationIcon = () => (<svg width="20" height="20" fill="currentColor"><path d="M10 18c.83 0 1.5-.67 1.5-1.5h-3c0 .83.67 1.5 1.5 1.5zm4.5-4.5V9c0-2.3-1.22-4.23-3.38-4.74V4c0-.62-.5-1.12-1.12-1.12-.62 0-1.12.5-1.12 1.12v.26C6.72 4.77 5.5 6.7 5.5 9v4.5L4.12 14.88c-.1.1-.22.25-.22.45V16h12.2v-.67c0-.2-.12-.35-.22-.45L14.5 13.5z"/></svg>);
const ModerationIcon = () => (<svg width="20" height="20" fill="orange"><rect x="2" y="2" width="16" height="16" rx="2"/><text x="3" y="14" fontSize="7" fill="#fff">MOD</text></svg>);
const APIIcon = () => (<svg width="20" height="20" fill="blue"><rect x="2" y="2" width="16" height="16" rx="2"/><text x="4" y="14" fontSize="7" fill="#fff">API</text></svg>);

export default function YouTubeCard({ post, user, onClick, onEdit, onPostDeleted }) {
  const videoUrl = post.videos?.[0]?.url || post.images?.[0]?.url;
  const thumbnail = post.videos?.[0]?.thumbnail || post.images?.[0]?.url || post.youtubeData?.thumbnail;
  const duration = post.videos?.[0]?.duration || post.youtubeData?.duration;
  const youtubeData = post.youtubeData || {};

  const formatDuration = (seconds) => {
    if (!seconds) return "";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    if (mins >= 60) {
      const hours = Math.floor(mins / 60);
      const remainMins = mins % 60;
      return `${hours}:${remainMins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    }
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const formatViews = (views) => {
    if (!views) return "0";
    if (views >= 1000000) {
      return `${(views / 1000000).toFixed(1)}M`;
    }
    if (views >= 1000) {
      return `${(views / 1000).toFixed(1)}K`;
    }
    return views.toString();
  };

  return (
    <div className="youtube_card" onClick={() => onClick(post)}>
      <div className="youtube_thumbnail">
        {thumbnail ? (
          <img src={thumbnail} alt="" />
        ) : videoUrl ? (
          <video src={videoUrl} preload="metadata" />
        ) : (
          <div className="youtube_no_thumbnail">
            <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
              <path d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73z" />
            </svg>
          </div>
        )}
        {duration && (
          <span className="youtube_duration">{formatDuration(duration)}</span>
        )}
        <div className="youtube_play_icon">
          <svg viewBox="0 0 24 24" fill="white" width="48" height="48">
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>

      <div className="youtube_card_info">
        <Link to={`/profile/${post.user.username}`} className="youtube_channel_avatar">
          <img src={post.user.picture} alt="" />
        </Link>

        <div className="youtube_card_details">
          <h3 className="youtube_title">
            {youtubeData.title || post.text || "Vídeo sem título"}
          </h3>

          <div className="youtube_meta">
            <Link to={`/profile/${post.user.username}`} className="youtube_channel_name">
              {post.user.first_name} {post.user.last_name}
            </Link>
            <div className="youtube_stats">
              <span>{formatViews(post.shares?.length || 0)} visualizações</span>
              <span>•</span>
              <Moment fromNow locale="pt-br">{post.createdAt}</Moment>
            </div>
          </div>
        </div>

        <div onClick={(e) => e.stopPropagation()}>
          <FeedPostMenu
            post={post}
            onEdit={onEdit}
            onPostDeleted={onPostDeleted}
          />
        </div>
      </div>

      {/* Botões Ultra-Avançados */}
      <div className="youtube_advanced_actions" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => alert("AR effects")} title="AR Effects" className="advanced_btn">
          <ARIcon />
        </button>
        <button onClick={() => alert("Challenges")} title="Desafios" className="advanced_btn">
          <ChallengeIcon />
        </button>
        <button onClick={() => alert("Live")} title="Transmissão ao vivo" className="advanced_btn">
          <LiveIcon />
        </button>
        <button onClick={() => alert("Privacy")} title="Privacidade" className="advanced_btn">
          <PrivacyIcon />
        </button>
        <button onClick={() => alert("Notifications")} title="Notificações" className="advanced_btn">
          <NotificationIcon />
        </button>
        <button onClick={() => alert("Moderation")} title="Moderação" className="advanced_btn">
          <ModerationIcon />
        </button>
        <button onClick={() => alert("API")} title="API Integrations" className="advanced_btn">
          <APIIcon />
        </button>
      </div>
    </div>
  );
}
